import { render, staticRenderFns } from "./ABAddOrEditText.vue?vue&type=template&id=2c363914&scoped=true"
import script from "./ABAddOrEditText.vue?vue&type=script&lang=js"
export * from "./ABAddOrEditText.vue?vue&type=script&lang=js"
import style0 from "./ABAddOrEditText.vue?vue&type=style&index=0&id=2c363914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c363914",
  null
  
)

export default component.exports